<template>
  <WidgetCard title="ÖVRIGA INKOMNA ÄRENDEN" subtitle="ATT HANTERA">
    <v-data-table
      hide-default-footer
      :headers="[
        {text: 'ÄRENDE', value: 'case', width: '180', sortable: false},
        {text: 'Avtalstillhörighet', value: 'contractType', width: '129', sortable: false},
        {text: 'Avser', value: 'name', width: '280', sortable: false},
        {text: 'Region', value: 'region', width: '180', sortable: false},
        {text: 'Status/Agerat', value: 'issuedBy', width: '180', sortable: false},
        {text: 'Datum', value: 'issuedOn', sortable: false, width: '100'},
        {text: '', value: 'notes', sortable: false, width: '50'}
      ]"
      :items="items"
      item-key="id"
      class="clickable"
      :items-per-page="-1"
      @click:row="clickedRow"
    >
      <!-- Application name header -->
      <template slot="item.name" slot-scope="props"
        >{{ props.item.name }} ({{ props.item.personalNumber | formatSecretPnr }})</template
      >
      <!-- Application issued On header -->
      <template slot="item.issuedOn" slot-scope="props">
        <span class="widget-normal">{{ props.item.issuedOn | date }}</span>
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<script>
import API from '@/services/api'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
import { printStatus } from '@/helpers'
import { mapGetters } from 'vuex'
import { get } from 'lodash';

// @group Widgets
// OtherCases component
export default {
  name: 'OtherCases',

  data: () => ({
    educations: [],
    bookPauses: [],
    qualificationTimes: [],
    basicEducationExtensions: [],
    specialCourseApprovals: []
  }),

  watch: {  
    handledCasesAreVisible: {
      handler(val) {
        this.fetchData()
      }
    }
  },

  computed: {
    ...mapGetters('currentuser', ['handledCasesAreVisible']),

    items() {
      return this.educations.concat(
        this.bookPauses,
        this.qualificationTimes,
        this.basicEducationExtensions,
        this.specialCourseApprovals
      )
    }
  },

  components: {
    WidgetCard
  },

  created() {
    this.fetchData()
  },

  methods: {
    printStatus,

    fetchData() {
      Promise.all([
        this.getBookPauses(),
        this.getQualificationWidget(),
        this.getEducationExtensionWidget(),
        this.specialCourseApprovalWidget()
      ])
    },

    /**
     * @vuese
     * Go to the application if clicked Education row else go to person detail view.
     * @arg called with no argument
     */
    clickedRow(item) {
      let appId = 0

      if (item.educationId) {
        API.listApplications({
          startAt: 0,
          sortBy: 'lastName',
          sortDesc: 'ASC',
          advSearch: {personalNumber: item.personalNumber},
          pageSize: 10
        })
          .then(response => {
            appId = response.data.rows.find(x => x.educationId == item.educationId).id
            this.$router.push({name: 'Application', params: {id: appId}}).catch(() => {})
          })
          .catch(error => {
            //console.log('There was an error:', error.response)
            this.$nextTick(() =>
              this.$router.push({name: 'PersonDetail', params: {id: item.personId}, query: {tab: '3'}}).catch(() => {})
            )
          })
      } else {
        this.$nextTick(() =>
          this.$router.push({name: 'PersonDetail', params: {id: item.personId}, query: {tab: '3'}}).catch(() => {})
        )
      }
    },

    getBookPauses() {
      let arr = []

      const params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }

      API.widgetBookPauses(params)
        .then(res => {
          let pNr = '',
            pId = '',
            fullname = '',
            region, 
            caseName = '',
            state = ''
          res.data.rows.forEach(el => {
            if(el.book && el.book.person){
              caseName = 'Uppehåll (grundutbildning)'
              if (el.book.person.firstName) fullname = el.book.person.firstName + ' '
                else fullname = ''
              if (el.book.person.lastName) fullname = fullname + el.book.person.lastName
              if (el.book.person.personalNumber) pNr = el.book.person.personalNumber
              else pNr = ''
              if (el.book.personId) pId = el.book.personId
              else pNr = ''
              if (el.region && el.region.name) region = el.region.name
              else region = ''
            }
            else if(el.education && el.education.person){
              caseName = 'Uppehåll (kvalificeringstid)'
              if (el.education.person.firstName) fullname = el.education.person.firstName + ' '
                else fullname = ''
              if (el.education.person.lastName) fullname = fullname + el.education.person.lastName
              if (el.education.person.personalNumber) pNr = el.education.person.personalNumber
              else pNr = ''
              if (el.education.personId) pId = el.education.personId
              else pNr = ''
              if (el.region && el.region.name) region = el.region.name
              else region = ''
            }
            
            if (el.approved && el.approved == true) state = 'Godkänd'
            else {
              state = 'Väntar på godk.'
            }

            let employmentType

            if( el.person?.employments.length ) {
              employmentType = el.person?.employments[0]
            }

            if( el.book?.apprenticeship ) {
              employmentType = el.book?.apprenticeship
            }

            arr.push({
              //personalNumber: res.data.personalNumber,
              case: caseName,
              contractType: employmentType?.company?.contracttype?.name ?? '',
              personalNumber: pNr,
              personId: pId,
              //name: `${res.data.firstName} ${res.data.lastName}`,
              name: fullname,
              region: region,
              state: state,
              issuedOn: el.updatedAt ? el.updatedAt : '',
              issuedBy: el?.createdBy ? `${ el.createdBy?.firstName } ${ el.createdBy.lastName }` : null
            })
          })
          this.bookPauses = arr
        })
        .catch(error => {
          console.log(error)
        })
    },
    getQualificationWidget() {
      this.qualificationTimes = []

      const params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }

      API.getQualificationTimeWidget(params)
        .then(res => {
          res.data.rows.forEach(ed => {

            let employmentType

            if( ed.qualificationTime?.education?.currentApprenticeship ) {
              employmentType = ed.qualificationTime?.education?.currentApprenticeship
            }

            if( ed.qualificationTime?.education?.person?.employments.length ) {
              employmentType = ed.qualificationTime?.education?.person?.employments[0]
            }
            
            this.qualificationTimes.push({
              case: 'Förändring av kvalificeringstid',
              contractType: employmentType?.company?.contracttype?.name ?? '',
              personalNumber: ed.qualificationTime&&ed.qualificationTime.education&&ed.qualificationTime.education.person && ed.qualificationTime.education.person.personalNumber ? ed.qualificationTime.education.person.personalNumber : '',
              personId: ed.qualificationTime&&ed.qualificationTime.education&&ed.qualificationTime.education.person && ed.qualificationTime.education.person.id ? ed.qualificationTime.education.person.id : '',
              name: ed.qualificationTime&&ed.qualificationTime.education&&ed.qualificationTime.education.person && ed.qualificationTime.education.person.id ? this.$options.filters.fullName(ed.qualificationTime.education.person) : '',
              region: ed.qualificationTime&&ed.qualificationTime.education&&ed.qualificationTime.education.region && ed.qualificationTime.education.region.name ? ed.qualificationTime.education.region.name : '',
              state: ed.approved && ed.approved == true ?'Godkänd':'Väntar på godk.',
              issuedOn: ed.fromDate ? ed.fromDate : '',
              issuedBy: ed?.approvedBy ? `${ ed.approvedBy?.firstName } ${ ed.approvedBy.lastName }` : null
            })
          })
        })
        .catch(error => {
          console.log('get document error, ', error)
        })
    },

    getEducationExtensionWidget() {
      this.basicEducationExtensions = []

      const params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }

      API.getEducationExtensionWidget(params)
        .then(res => {
          res.data.rows.forEach(eduExtension => {

            let employmentType

            if( eduExtension?.education?.currentApprenticeship ) {
              employmentType = eduExtension?.education?.currentApprenticeship
            }

            if( eduExtension.qualificationTime?.education?.person?.employments.length ) {
              employmentType = eduExtension?.education?.person?.employments[0]
            }
            
            this.basicEducationExtensions.push({
              case: 'Förlängning av grundutbildningstid',
              contractType: employmentType?.company?.contracttype?.name ?? '',
              personalNumber: eduExtension.education.person.personalNumber,
              personId: eduExtension.education.person.id,
              name: this.$options.filters.fullName(eduExtension.education.person),
              region: eduExtension.education.region.name,
              state: eduExtension.approved ? 'Godkänd' : 'Väntar på godk.',
              issuedOn: eduExtension.createdAt,
              issuedBy: eduExtension?.approvedBy ? `${ eduExtension.approvedBy?.firstName } ${ eduExtension.approvedBy.lastName }` : null
            })
          })
        })
        .catch(error => {
          console.log('get document error, ', error)
        })
    },

    async specialCourseApprovalWidget() {
      try {
        const params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }
        const { data } = await API.specialCourseApprovalWidget(params)
        this.specialCourseApprovals = get(data, 'rows', []).map(row => ({
          case: 'Klarmarkera fördjupningskurs',
          contractType: get(row, 'book.apprenticeship.company.contracttype.name', ''),
          personalNumber: get(row, 'book.person.personalNumber', ''),
          personId: get(row, 'book.person.id', ''),
          name: this.$options.filters.fullName(get(row, 'book.person', null)),
          region: get(row, 'book.region.name', ''),
          state: get(row, 'status', ''),
          issuedOn: get(row, 'firstApprovedAt', ''),
          issuedBy: this.$options.filters.fullName(get(row, 'approvedBy', ''))
        }))
      } catch {}
    }
  }
}
</script>

<style scoped>
</style>
